"use client";

import { RecoilRoot as RealRecoilRoot } from "recoil";

//Work around to get recoil root to load as client
export default RealRecoilRoot;
